import { useEffect, useState } from "react";
import { Table, Button, message, Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import { getHostSchedules, cancelHostSchedule } from "../../server/Hosts";
import dayjs from "dayjs";

export const ProviderSchedulesTable = ({ refreshTick = 0 }: { refreshTick?: number }) => {
  const { t } = useTranslation();
  const [schedules, setSchedules] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchSchedules = async () => {
    setLoading(true);
    try {
      const res = await getHostSchedules(true);
      setSchedules(res.data.data || []);
    } catch (err: any) {
      console.error(err);
      message.error(t("Failed to load schedules"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchedules();
  }, [refreshTick]);

  const handleCancel = async (hostId: string, scheduleId: string) => {
    try {
      await cancelHostSchedule(hostId, scheduleId);
      message.success(t("Schedule cancelled successfully"));
      fetchSchedules();
    } catch (err: any) {
      console.error(err);
      message.error(err?.response?.data?.msg || t("Failed to cancel schedule"));
    }
  };

  const columns = [
    {
      title: t("Schedule ID"),
      dataIndex: "schedule_id",
      key: "schedule_id",
    },
    {
      title: t("Host ID"),
      dataIndex: "host_id",
      key: "host_id",
    },
    {
      title: t("Type"),
      dataIndex: "type",
      key: "type",
      render: (type: string) => <span style={{ textTransform: 'capitalize' }}>{type}</span>
    },
    {
      title: t("Action"),
      dataIndex: "action",
      key: "action",
      render: (action: string) => (
        <span style={{ 
          color: action === 'online' ? '#52c41a' : '#f5222d',
          fontWeight: 500,
          textTransform: 'capitalize'
        }}>
          {action}
        </span>
      )
    },
    {
      title: t("Execute At / Cron"),
      key: "time",
      render: (_: any, record: any) => {
        if (record.type === 'once') {
          return dayjs(record.execute_at).format('YYYY-MM-DD HH:mm:ss');
        }
        return record.cron_expression;
      }
    },
    {
      title: t("Manage"),
      key: "manage",
      render: (_: any, record: any) => (
        <Popconfirm
          title={t("Cancel this schedule?")}
          onConfirm={() => handleCancel(record.host_id, record.schedule_id)}
          okText={t("Yes")}
          cancelText={t("No")}
        >
          <Button danger size="small">{t("Cancel")}</Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div style={{ marginTop: '2em' }}>
      <h3 style={{ marginBottom: '1em' }}>{t("Active Schedules")}</h3>
      <Table 
        columns={columns} 
        dataSource={schedules} 
        rowKey="schedule_id" 
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};
